import { render, staticRenderFns } from "./Jcsz.vue?vue&type=template&id=2aa81a94&scoped=true"
import script from "./Jcsz.vue?vue&type=script&lang=js"
export * from "./Jcsz.vue?vue&type=script&lang=js"
import style0 from "./Jcsz.vue?vue&type=style&index=0&id=2aa81a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa81a94",
  null
  
)

export default component.exports